/** @graphql agg **/

import gql from 'graphql-tag';
export const SiteInformationQuery = gql`
	query SiteInformationQuery {
		tenant {
			shard
			cloudId
			environment
			activationId
		}
		organization {
			orgId
		}
		userForAnalytics: confluence_atlassianUser {
			id
		}
		user: confluence_atlassianUser(current: true) {
			id
			displayName
			confluence {
				accessStatus
				accountId
				userKey
				locale
			}
			timeZone
		}
		getAIConfig(product: CONFLUENCE) {
			isEnabled
			isRovoEnabled
			isRovoLLMEnabled
		}
		confluence_tenantContext {
			licenseStates {
				confluence {
					ccpEntitlementId
				}
			}
			timeZone
			editions {
				confluence
			}
			monolithRegion
		}
		isSiteAdmin
		abTestCohorts
		experimentFeatures
		userCanCreateContent
		isNewUser
		siteSettings {
			homepage {
				uri
				title
			}
			siteTitle
			showApplicationTitle
			frontCover {
				frontCoverState
			}
			companyHubName
		}
		siteDescription {
			logoUrl
		}
		currentConfluenceUser {
			isAnonymous
		}
	}
`;
